// // // import React from 'react';

// // // const PrintingServices = () => {
// // //   const services = [
// // //     {
// // //       title: "Pre Press",
// // //       description: "Satyam Stands For Quality In printing and our group...",
// // //       bgImage: "/api/placeholder/400/300"
// // //     },
// // //     {
// // //       title: "Post Press",
// // //       description: "We take awesome pride in the quality introduction...",
// // //       bgImage: "/api/placeholder/400/300"
// // //     },
// // //     {
// // //       title: "Digital Printing",
// // //       description: "We are not only providing large scale offset printing...",
// // //       bgImage: "/api/placeholder/400/300"
// // //     },
// // //     {
// // //       title: "Offset Printing",
// // //       description: "We might want to present ourselves as a leading...",
// // //       bgImage: "/api/placeholder/400/300"
// // //     },
// // //     {
// // //       title: "Print Enhancement by MCI",
// // //       description: "We might want to present ourselves as a leading...",
// // //       bgImage: "/api/placeholder/400/300"
// // //     }
// // //   ];

// // //   return (
// // //     <div className="w-full bg-white py-8"> {/* Entire component background set to white */}
// // //       {/* Centering the content */}
// // //       <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
// // //         {/* Flex container to center the cards */}
// // //         <div className="flex flex-wrap justify-center gap-6">
// // //           {services.map((service, index) => (
// // //             <div
// // //               key={index}
// // //               className="w-full sm:w-80 md:w-96 h-56 sm:h-64 bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300"
// // //               style={{
// // //                 backgroundImage: `url(${service.bgImage})`,
// // //                 backgroundSize: 'cover',
// // //                 backgroundPosition: 'center',
// // //               }}
// // //             >
// // //               <div className="absolute bg-opacity-40"></div>
// // //               <div className="relative bg-pink-600 z-10 p-4 sm:p-6 flex flex-col h-full justify-between">
// // //                 <div>
// // //                   <h2 className="text-white text-lg sm:text-xl font-bold mb-2">
// // //                     {service.title}
// // //                   </h2>
// // //                   <p className="text-white text-xs sm:text-sm mb-4">
// // //                     {service.description}
// // //                   </p>
// // //                 </div>
// // //                 <button className="bg-transparent border-2 border-white text-white px-4 py-2 rounded-full text-sm hover:bg-white hover:text-pink-600 transition-colors duration-300">
// // //                   MORE INFO
// // //                 </button>
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default PrintingServices;


// // // export default function Services() {
// // //     const services = [
// // //       { 
// // //         title: "Business Printing", 
// // //         description: "Professional cards, letterheads, and stationery that make your brand stand out",
// // //         icon: "🖨️",
// // //         color: "bg-blue-100"
// // //       },
// // //       {
// // //         title: "Large Format Printing",
// // //         description: "Eye-catching banners, posters, and signage for maximum impact",
// // //         icon: "📏",
// // //         color: "bg-purple-100"
// // //       },
// // //       {
// // //         title: "Promotional Materials",
// // //         description: "Custom brochures, flyers, and catalogs that convert",
// // //         icon: "📢",
// // //         color: "bg-orange-100"
// // //       },
// // //       {
// // //         title: "Packaging Solutions",
// // //         description: "Custom boxes and packaging that elevate your product",
// // //         icon: "📦",
// // //         color: "bg-green-100"
// // //       },
// // //       {
// // //         title: "Event Printing",
// // //         description: "Invitations, programs, and merchandise for memorable events",
// // //         icon: "🎉",
// // //         color: "bg-pink-100"
// // //       }
// // //     ];
  
// // //     return (
// // //       <section className="py-20 px-4 bg-white">
// // //         <div className="max-w-7xl mx-auto">
// // //           <div className="text-center mb-16">
// // //             <h2 className="text-4xl md:text-5xl font-heading font-bold bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent mb-4">
// // //               Our Premium Services
// // //             </h2>
// // //             <p className="text-gray-600 text-lg max-w-2xl mx-auto">
// // //               Delivering exceptional print solutions for businesses and individuals
// // //             </p>
// // //           </div>
  
// // //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
// // //             {services.map((service, index) => (
// // //               <div 
// // //                 key={index}
// // //                 className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 h-full"
// // //               >
// // //                 <div className={`${service.color} p-8 pb-16`}>
// // //                   <div className="mb-6">
// // //                     <span className="text-5xl">{service.icon}</span>
// // //                   </div>
// // //                   <h3 className="text-2xl font-bold text-gray-800 mb-4">
// // //                     {service.title}
// // //                   </h3>
// // //                   <p className="text-gray-600 leading-relaxed">
// // //                     {service.description}
// // //                   </p>
// // //                 </div>
// // //                 <div className="absolute bottom-0 left-0 right-0 h-16 bg-white/90 flex items-center px-6 transition-all duration-300 group-hover:h-20">
// // //                   <button className="flex items-center gap-2 text-blue-900 font-semibold hover:text-blue-700">
// // //                     Learn More
// // //                     <svg 
// // //                       xmlns="http://www.w3.org/2000/svg" 
// // //                       className="h-5 w-5 transition-transform group-hover:translate-x-1" 
// // //                       fill="none" 
// // //                       viewBox="0 0 24 24" 
// // //                       stroke="currentColor"
// // //                     >
// // //                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
// // //                     </svg>
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
  
// // //           <div className="mt-16 text-center">
// // //             <p className="text-gray-600 mb-6">Don't see what you're looking for?</p>
// // //             <button className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-3 rounded-full font-semibold hover:from-blue-700 hover:to-blue-600 transition-all shadow-lg hover:shadow-xl">
// // //               Custom Order Inquiry
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </section>
// // //     )
// // //   }


// // // export default function Services() {
// // //     const services = [
// // //       { 
// // //         title: "Pre Press",
// // //         description: "Suzens Sound, for Quality in all. Precision prepress services ensuring flawless print preparation",
// // //         icon: "🎨",
// // //         color: "bg-blue-100"
// // //       },
// // //       {
// // //         title: "Post Press",
// // //         description: "Comprehensive finishing services with quality circulation management",
// // //         icon: "🖨️",
// // //         color: "bg-purple-100"
// // //       },
// // //       {
// // //         title: "Digital Printing",
// // //         description: "Advanced digital solutions building on traditional printing excellence",
// // //         icon: "💻",
// // //         color: "bg-orange-100"
// // //       },
// // //       {
// // //         title: "Offset Printing",
// // //         description: "High-precision symbol and text reproduction for critical reading materials",
// // //         icon: "📜",
// // //         color: "bg-green-100"
// // //       },
// // //       {
// // //         title: "Print Enhancement by MCI",
// // //         description: "Amplified printing solutions that make your message stand out loud and clear",
// // //         icon: "✨",
// // //         color: "bg-pink-100"
// // //       }
// // //     ];
  
// // //     return (
// // //       <section className="py-20 px-4 bg-gray-50">
// // //         <div className="max-w-7xl mx-auto">
// // //           <div className="text-center mb-16">
// // //             <h2 className="text-4xl md:text-5xl font-heading font-bold bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text text-transparent mb-4">
// // //               Precision Printing Solutions
// // //             </h2>
// // //             <p className="text-gray-600 text-lg max-w-2xl mx-auto">
// // //               End-to-end printing services from prepress to post-press perfection
// // //             </p>
// // //           </div>
  
// // //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
// // //             {services.map((service, index) => (
// // //               <div 
// // //                 key={index}
// // //                 className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 h-full"
// // //               >
// // //                 <div className={`${service.color} p-6 pb-14`}>
// // //                   <div className="mb-4">
// // //                     <span className="text-4xl">{service.icon}</span>
// // //                   </div>
// // //                   <h3 className="text-xl font-bold text-gray-800 mb-3">
// // //                     {service.title}
// // //                   </h3>
// // //                   <p className="text-gray-600 text-sm leading-relaxed">
// // //                     {service.description}
// // //                   </p>
// // //                 </div>
// // //                 <div className="absolute bottom-0 left-0 right-0 h-12 bg-white/90 flex items-center px-4 transition-all duration-300 group-hover:h-16">
// // //                   <button className="flex items-center gap-1 text-blue-900 text-sm font-semibold hover:text-blue-700">
// // //                     Explore Process
// // //                     <svg 
// // //                       xmlns="http://www.w3.org/2000/svg" 
// // //                       className="h-4 w-4 transition-transform group-hover:translate-x-1" 
// // //                       fill="none" 
// // //                       viewBox="0 0 24 24" 
// // //                       stroke="currentColor"
// // //                     >
// // //                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
// // //                     </svg>
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
  
// // //           <div className="mt-16 text-center">
// // //             <div className="bg-white p-8 rounded-2xl shadow-inner border border-gray-100 max-w-3xl mx-auto">
// // //               <h3 className="text-2xl font-bold text-gray-800 mb-4">POST LIVES</h3>
// // //               <p className="text-gray-600 mb-6">
// // //                 Continuous quality circulation management and post-production support
// // //               </p>
// // //               <button className="bg-gradient-to-r from-gray-800 to-gray-700 text-white px-6 py-2 rounded-full text-sm font-semibold hover:from-gray-900 hover:to-gray-800 transition-all">
// // //                 View Circulation Details
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>
// // //     )
// // //   }

// // export default function Services() {
// //     const services = [
// //       { 
// //         title: "Pre Press",
// //         description: "Precision prepress services ensuring flawless print preparation",
// //         icon: "🎨",
// //         color: "bg-primary-100"
// //       },
// //       {
// //         title: "Post Press",
// //         description: "Comprehensive finishing services with quality circulation management",
// //         icon: "🖨️",
// //         color: "bg-accent-100"
// //       },
// //       {
// //         title: "Digital Printing",
// //         description: "Advanced digital solutions building on traditional excellence",
// //         icon: "💻",
// //         color: "bg-primary-100"
// //       },
// //       {
// //         title: "Offset Printing",
// //         description: "High-precision reproduction for critical materials",
// //         icon: "📜",
// //         color: "bg-accent-100"
// //       },
// //       {
// //         title: "Print Enhancement",
// //         description: "Solutions that make your message stand out",
// //         icon: "✨",
// //         color: "bg-primary-100"
// //       }
// //     ];
  
// //     return (
// //       <section className="py-20 px-4 bg-primary-50">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="text-center mb-16">
// //             <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary-900 mb-4">
// //               Precision Printing Solutions
// //             </h2>
// //             <p className="text-secondary-600 text-lg max-w-2xl mx-auto">
// //               End-to-end services from prepress to post-press perfection
// //             </p>
// //           </div>
  
// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
// //             {services.map((service, index) => (
// //               <div 
// //                 key={index}
// //                 className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 h-full"
// //               >
// //                 <div className={`${service.color} p-6 pb-14`}>
// //                   <div className="mb-4">
// //                     <span className="text-4xl text-primary-700">{service.icon}</span>
// //                   </div>
// //                   <h3 className="text-xl font-bold text-primary-900 mb-3">
// //                     {service.title}
// //                   </h3>
// //                   <p className="text-secondary-600 text-sm leading-relaxed">
// //                     {service.description}
// //                   </p>
// //                 </div>
// //                 <div className="absolute bottom-0 left-0 right-0 h-12 bg-white/90 flex items-center px-4 transition-all duration-300 group-hover:h-16">
// //                   <button className="flex items-center gap-1 text-primary-700 text-sm font-semibold hover:text-primary-900">
// //                     Explore Process
// //                     <svg 
// //                       xmlns="http://www.w3.org/2000/svg" 
// //                       className="h-4 w-4 transition-transform group-hover:translate-x-1" 
// //                       fill="none" 
// //                       viewBox="0 0 24 24" 
// //                       stroke="currentColor"
// //                     >
// //                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
// //                     </svg>
// //                   </button>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>
// //     )
// //   }

// export default function ServicesSection() {
//     const services = [
//       { 
//         title: "Pre Press",
//         description: "Professional prepress services with precision color management",
//         icon: "🎨",
//         color: "bg-primary-100"
//       },
//       {
//         title: "Offset Printing",
//         description: "High-quality offset printing for bulk commercial needs",
//         icon: "🖨️",
//         color: "bg-accent-100"
//       },
//       {
//         title: "Digital Printing",
//         description: "Quick turnaround digital solutions for short runs",
//         icon: "💻",
//         color: "bg-primary-100"
//       },
//       {
//         title: "Post Press",
//         description: "Expert finishing and binding services",
//         icon: "📦",
//         color: "bg-accent-100"
//       },
//       {
//         title: "Packaging",
//         description: "Custom packaging solutions with premium finishes",
//         icon: "🎁",
//         color: "bg-primary-100"
//       }
//     ];
  
//     return (
//       <section className="my-20 py-20 px-4 bg-primary-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary-base mb-4">
//               Our Printing Expertise
//             </h2>
//             <p className="text-secondary-600 text-lg max-w-2xl mx-auto">
//               Comprehensive solutions from concept to finished product
//             </p>
//           </div>
  
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
//             {services.map((service, index) => (
//               <div 
//                 key={index}
//                 className="group relative overflow-hidden rounded-xl border-y-2 border-accent-base shadow-lg hover:shadow-2xl transition-all duration-300 h-full"
//               >
//                 <div className={`${service.color} p-6 pb-14`}>
//                   <div className="mb-4">
//                     <span className="text-4xl text-primary-700">{service.icon}</span>
//                   </div>
//                   <h3 className="text-xl font-bold text-primary-base mb-3">
//                     {service.title}
//                   </h3>
//                   <p className="text-secondary-600 text-sm leading-relaxed">
//                     {service.description}
//                   </p>
//                 </div>
//                 <div className="absolute bottom-0 left-0 right-0 h-12 bg-white/90 flex items-center px-4 transition-all duration-300 group-hover:h-16">
//                   <button className="flex items-center gap-1 text-accent-base text-sm font-semibold hover:text-primary-900">
//                     View Details
//                     <svg 
//                       xmlns="http://www.w3.org/2000/svg" 
//                       className="h-4 w-4 transition-transform group-hover:translate-x-1" 
//                       fill="none" 
//                       viewBox="0 0 24 24" 
//                       stroke="currentColor"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     )
//   }

import { Link } from 'react-router-dom';

export default function ServicesSection() {
  const services = [
    { 
      title: "Pre Press",
      description: "Professional prepress services with precision color management",
      icon: "🎨",
      color: "bg-primary-100",
      link: "/services/pre-press"  // Add unique links for each service
    },
    {
      title: "Offset Printing",
      description: "High-quality offset printing for bulk commercial needs",
      icon: "🖨️",
      color: "bg-accent-100",
      link: "/services/offset-printing"
    },
    {
      title: "Digital Printing",
      description: "Quick turnaround digital solutions for short runs",
      icon: "💻",
      color: "bg-primary-100",
      link: "/services/digital-printing"
    },
    {
      title: "Post Press",
      description: "Expert finishing and binding services",
      icon: "📦",
      color: "bg-accent-100",
      link: "/services/post-press"
    },
    {
      title: "Packaging",
      description: "Custom packaging solutions with premium finishes",
      icon: "🎁",
      color: "bg-primary-100",
      link: "/services/packaging"
    }
  ];

  return (
    <section className="my-20 py-20 px-4 bg-primary-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-primary-base mb-4">
            Our Printing Expertise
          </h2>
          <p className="text-secondary-600 text-lg max-w-2xl mx-auto">
            Comprehensive solutions from concept to finished product
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-xl border-y-2 border-accent-base shadow-lg hover:shadow-2xl transition-all duration-300 h-full"
            >
              <div className={`${service.color} p-6 pb-14`}>
                <div className="mb-4">
                  <span className="text-4xl text-primary-700">{service.icon}</span>
                </div>
                <h3 className="text-xl font-bold text-primary-base mb-3">
                  {service.title}
                </h3>
                <p className="text-secondary-600 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-white/90 flex items-center px-4 transition-all duration-300 group-hover:h-16">
                <Link to={service.link}>
                  <button className="flex items-center gap-1 text-accent-base text-sm font-semibold hover:text-primary-900">
                    View Details
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-4 w-4 transition-transform group-hover:translate-x-1" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
